import "../assets/Tooltip.css";
import { defineComponent as D, useCssVars as R, unref as r, ref as n, computed as _, openBlock as V, createBlock as z, Transition as L, withCtx as N, withDirectives as W, createElementVNode as w, normalizeStyle as X, createTextVNode as P, toDisplayString as Y, vShow as j } from "vue";
import { u as q } from "./index.AJuLibkw.js";
import { d as o, n as A } from "./useStore.CDG6wbfK.js";
const F = ["data-to-left"], g = 20, y = 10, c = 8, b = 10, M = /* @__PURE__ */ D({
  __name: "Tooltip",
  props: {
    autoHide: {},
    backColor: { default: "#88001e" },
    color: { default: "#ffffff" }
  },
  setup(C, { expose: S }) {
    R((t) => ({
      "16deb290": t.backColor,
      "7cbdfd42": t.color,
      "85e82942": r(o)(y),
      "85e82980": r(o)(g),
      "2b32d690": r(o)(b),
      "2b32da70": r(o)(c)
    }));
    const l = A(), f = C, s = n(), i = n(), u = n(!1), d = n(), a = n(), { width: T, height: k } = q(i), p = _(() => {
      if (a.value && (l != null && l.styles.rootElement)) {
        const {
          left: t,
          width: e
        } = l.styles.rootElement.getBoundingClientRect();
        return a.value.left > t + e / 2;
      }
      return !1;
    }), x = _(() => {
      if (a.value && i.value) {
        const {
          left: t,
          top: e
        } = a.value, h = b + c, E = k.value + y * 2 + c, B = T.value + g * 2;
        return {
          top: o(e - E),
          left: o(t - (p.value ? B - h : h))
        };
      }
      return {};
    });
    function v() {
      s.value && (clearTimeout(s.value), s.value = null);
    }
    function m() {
      v(), u.value = !1;
    }
    function H(t, e) {
      v(), u.value = !0, a.value = e, d.value = t, f.autoHide && (s.value = setTimeout(() => {
        m();
      }, f.autoHide));
    }
    return S({
      show: H,
      hide: m
    }), (t, e) => (V(), z(L, { name: "fade-tooltip" }, {
      default: N(() => [
        W(w("div", {
          class: "thn--tool-tooltip",
          ref_key: "rootRef",
          ref: i,
          style: X(x.value)
        }, [
          w("span", {
            class: "thn--tool-tooltip__arrow",
            "data-to-left": p.value
          }, null, 8, F),
          P(" " + Y(d.value), 1)
        ], 4), [
          [j, u.value]
        ])
      ]),
      _: 1
    }));
  }
});
export {
  M as _
};
//# sourceMappingURL=Tooltip.vue_vue_type_style_index_0_lang.BZsawpJG.js.map
